// src/services/assetTypeService.js
import { authenticatedFetch } from './api';

/**
 * Uploads a new default 3D model for a given asset type.
 * @param {string} assetType - The type of the asset (e.g., 'street_light').
 * @param {FormData} formData - The form data containing the model file.
 * @returns {Promise<object>} The server response.
 */
export const updateAssetTypeModel = async (assetType, formData) => {
  // The endpoint will be created in the backend in the next step
  return await authenticatedFetch(`/asset-types/${assetType}/model`, {
    method: 'PUT',
    body: formData, // No 'Content-Type' header needed, browser sets it for FormData
  });
};